import React, {useEffect} from "react";
import { useTranslation, Trans } from "react-i18next";
import TopSearchbox from "./search/TopSearchbox";
import {IActivity} from "../types/Activity";
import {PlanSearch} from "../types/Search";
import {PlanSelectFormData} from "../types/planSelectForm";
import {FreeSpace, FreeSpaceBanner, FreeSpaceContent} from "../types/Freespace";
// for HTML
import DOMPurify from 'dompurify';
import draftToHtml from 'draftjs-to-html';
import {isAdminFreeSpacePC, isAdminFreeSpaceSP, markupContentExist} from "../utils/freeSpace";

type Props = {
  freeSpaceContent: FreeSpace|undefined
}

const FreeSpaceSection: React.FC<Props> = ({
  freeSpaceContent
}) => {
  
  const { t, i18n } = useTranslation();
  const [freeSpace, setFreeSpace] = React.useState<FreeSpace>();
  const [banner, setBanner] = React.useState<FreeSpaceBanner>();
  const [content, setContent] = React.useState<FreeSpaceContent>();
  const [adminContent, setAdminContent] = React.useState<FreeSpaceContent>();
  
  useEffect(() => {
    if (freeSpaceContent) {
      setFreeSpace({...freeSpaceContent});
      getBannerByLanguage(freeSpaceContent);
      getContentByLanguage(freeSpaceContent);
      getAdminContentByLanguage(freeSpaceContent);
    }
  },[freeSpaceContent])
  
  // 言語別バナー取得
  const getBannerByLanguage = (freeSpace: FreeSpace|undefined) => {
    if(!freeSpace) return;
    if(i18n.language === 'en') {
      if(freeSpace.freeSpace && freeSpace.freeSpace.banner_en) {
        setBanner({...freeSpace.freeSpace.banner_en});
      }
    } else {
      if(freeSpace.freeSpace && freeSpace.freeSpace.banner) {
        setBanner({...freeSpace.freeSpace.banner});
      }
    }
  }
  
  // 言語別コンテンツ取得
  const getContentByLanguage = (freeSpace: FreeSpace|undefined) => {
    if(!freeSpace) return;
    if(i18n.language === 'en') {
      console.log("freeSpace.freeSpace.content_en", freeSpace.freeSpace?.content_en);
      if(freeSpace.freeSpace && freeSpace.freeSpace.content_en) {
        setContent({...freeSpace.freeSpace.content_en});
      }
    } else {
      if(freeSpace.freeSpace && freeSpace.freeSpace.content) {
        setContent({...freeSpace.freeSpace.content});
      }
    }
  }
  
  // 言語別管理者コンテンツ取得
  const getAdminContentByLanguage = (freeSpace: FreeSpace|undefined) => {
    if(!freeSpace) return;
    if(i18n.language === 'en') {
      if(freeSpace.adminFreeSpace && freeSpace.adminFreeSpace.content_en) {
        setAdminContent({...freeSpace.adminFreeSpace.content_en});
      }
    } else {
      if(freeSpace.adminFreeSpace && freeSpace.adminFreeSpace.content) {
        setAdminContent({...freeSpace.adminFreeSpace.content});
      }
    }
  }

  const createMarkup = (content: string) => {
    if(content) {
      const html = draftToHtml(JSON.parse(content));
      return  {
          __html: DOMPurify.sanitize(html, { ADD_ATTR: ['target'] })
      }
    }
  }

  return (
    <>
    {banner && banner?.pc && banner?.sp ?
    <>
      {/* バナー */}
      <div className="wrap-content-900-no_padding">
        <div className="mb-0">
          <a href={banner.link} target="_blank" className="parts-hover w-100per">
            <picture>
              <source
                srcSet={banner.pc}
                media="(min-width: 992px)"
              />
              <img
                src={banner.sp}
                alt="バナー"
              />
            </picture>
          </a>
        </div>
      </div>
    </>:<></>  
    }

    {/* フリースペース */}
    {/* PC */}
    <div className="box-freespace">
      {
        isAdminFreeSpacePC(freeSpace, i18n.language) && (
          <div className="box-freespace-item">
            <div className="wrap-content-900 d-n d-b-md">
              <div className="box-alert-red-small icon-alert mt-16-md">
                <p className="fz-14 fz-16-md c-red fw-b mb-8"><i className="icon-alert"></i>{t("重要なお知らせ")}</p>
                {freeSpace?.okinawaSaihakkenFreeSpace?.content.pc && markupContentExist(freeSpace.okinawaSaihakkenFreeSpace.content.pc) &&
                  <div className="freespace-wrap mb-20">
                    <div className="freespace-wrap-item">
                      <p className="fz-14" dangerouslySetInnerHTML={createMarkup(freeSpace.okinawaSaihakkenFreeSpace.content.pc)}></p>
                    </div>
                  </div>
                }
                {adminContent && adminContent.pc && markupContentExist(adminContent.pc) &&
                  <div className="freespace-wrap">
                    <div className="freespace-wrap-item">
                      <p className="fz-14" dangerouslySetInnerHTML={createMarkup(adminContent.pc)}></p>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        )
      }

      {/* SP */}
      {
        isAdminFreeSpaceSP(freeSpace, i18n.language) && (
          <div className="box-freespace-item">
            <div className="wrap-content-900 d-n-md">
              <div className="box-alert-red-small icon-alert mt-16-md">
                <p className="fz-14 fz-16-md fw-b c-red mb-8"><i className="icon-alert"></i>{t("重要なお知らせ")}</p>
                {freeSpace?.okinawaSaihakkenFreeSpace?.content?.sp && markupContentExist(freeSpace.okinawaSaihakkenFreeSpace.content.sp) &&
                  <div className="freespace-wrap mb-20">
                    <div className="freespace-wrap-item">
                      <p className="fz-14" dangerouslySetInnerHTML={createMarkup(freeSpace.okinawaSaihakkenFreeSpace.content.sp)}></p>
                    </div>
                  </div>
                }
                {adminContent?.sp && markupContentExist(adminContent.sp) &&
                  <div className="freespace-wrap">
                    <div className="freespace-wrap-item">
                      <p className="fz-14" dangerouslySetInnerHTML={createMarkup(adminContent.sp)}></p>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        )
      }

      {/* サービス保険 //PC */}
      {(i18n.language === 'ja' && freeSpace && freeSpace?.serviceInsuranceFreeSpace?.pc && markupContentExist(freeSpace?.serviceInsuranceFreeSpace?.pc)) ?
      <>
        <div className="box-freespace-item">
          <div className="wrap-content-900 d-n d-b-md">
            <div className="box-infomation-small mt-16-md mb-16">
              <p className="fz-16 fw-b c-navy mb-8"><i className="icon-infomation"></i>サービス保険について</p>
              <div className="freespace-wrap">
                <div className="freespace-wrap-item">
                  <p className="fz-14" dangerouslySetInnerHTML={createMarkup(freeSpace?.serviceInsuranceFreeSpace?.pc)}></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </> : ""
      }

      {/* サービス保険 //SP */}
      {(i18n.language === 'ja' && freeSpace && freeSpace?.serviceInsuranceFreeSpace?.sp && markupContentExist(freeSpace?.serviceInsuranceFreeSpace.sp)) ?
      <>
        <div className="box-freespace-item">
          <div className="wrap-content-900 d-n-md">
            <div className="box-infomation-small mt-16-md mb-16">
              <p className="fz-14 fw-b c-navy mb-8"><i className="icon-infomation"></i>サービス保険について</p>
              <div className="freespace-wrap">
                <div className="freespace-wrap-item">
                  <p className="fz-14" dangerouslySetInnerHTML={createMarkup(freeSpace?.serviceInsuranceFreeSpace.sp)}></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </> : ""
      }

      {/* インフォメーション //PC */}
      {
      (freeSpace && content?.pc && markupContentExist(content.pc)) ?
      <>
        <div className="box-freespace-item">
          <div className="wrap-content-900 d-n d-b-md">
            <div className="box-infomation-small mt-16-md mb-16">
              <p className="fz-16 fw-b c-navy mb-8"><i className="icon-infomation"></i>{t("インフォメーション")}</p>
              <div className="freespace-wrap">
                <div className="freespace-wrap-item">
                  <p className="fz-14" dangerouslySetInnerHTML={createMarkup(content.pc)}></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </> : ""
      }

      {/* インフォメーション //SP */}
      {(freeSpace && content?.sp && markupContentExist(content.sp)) ?
      <>
        <div className="box-freespace-item">
          <div className="wrap-content-900 d-n-md">
            <div className="box-infomation-small mt-16-md mb-16">
              <p className="fz-14 fw-b c-navy mb-8"><i className="icon-infomation"></i>{t("インフォメーション")}</p>
              <div className="freespace-wrap">
                <div className="freespace-wrap-item">
                  <p className="fz-14" dangerouslySetInnerHTML={createMarkup(content.sp)}></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </> : ""
      }
    </div>
  </>);
}

export default FreeSpaceSection;